import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'empresas/tipos-de-contratos-de-policias/';

/**
 * GET Tipos de Contratos de Policias
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeContratosDePolicias = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Contrato de Policia
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeContratoDePolicia = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Contrato de Policia
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeContratoDePolicia = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de  Contrato de Policia
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeContratoDePolicia = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Contrato de Policia
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeContratoDePolicia = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
